function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8098 51.6744L18.6565 49.487C18.3268 49.3471 17.9612 49.5891 17.9612 49.9473V54.8202H84.2614V49.9902C84.2614 49.6211 83.8753 49.3792 83.5432 49.5403L79.2342 51.6306C78.74 51.8703 78.1691 51.8962 77.6553 51.7024L71.3763 49.3333C71.1356 49.2425 70.8693 49.248 70.6325 49.3484L65.1528 51.6744C64.6534 51.8863 64.0893 51.8863 63.5899 51.6744L58.132 49.3577C57.8823 49.2518 57.6003 49.2518 57.3506 49.3577L51.8927 51.6744C51.3933 51.8863 50.8293 51.8863 50.3299 51.6744L44.872 49.3577C44.6223 49.2518 44.3403 49.2518 44.0906 49.3577L38.6327 51.6744C38.1333 51.8863 37.5692 51.8863 37.0698 51.6744L31.6119 49.3577C31.3622 49.2518 31.0802 49.2518 30.8305 49.3577L25.3726 51.6744C24.8732 51.8863 24.3092 51.8863 23.8098 51.6744Z",
  fill: "#EDEDED"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.3667 15.8554L35.0868 17.7294C35.7978 18.0117 36.5898 18.0117 37.3008 17.7294L42.3364 15.7301C42.5734 15.636 42.8374 15.636 43.0744 15.7301L48.11 17.7294C48.8211 18.0117 49.613 18.0117 50.324 17.7294L55.3597 15.7301C55.5967 15.636 55.8607 15.636 56.0977 15.7301L61.1333 17.7294C61.8443 18.0117 62.6363 18.0117 63.3473 17.7294L68.3829 15.7301C68.6199 15.636 68.8839 15.636 69.1209 15.7301L74.1566 17.7294C74.8676 18.0117 75.6596 18.0117 76.3706 17.7294L81.4268 15.7219C81.6514 15.6328 81.9007 15.6279 82.1286 15.7084L87.9623 17.7671C88.6928 18.0249 89.4948 17.9901 90.2002 17.67L94.0919 15.9042C94.4229 15.754 94.7984 15.9961 94.7984 16.3596V20.7541H29.6822V16.3201C29.6822 15.9669 30.0384 15.7251 30.3667 15.8554ZM29.6822 20.7544H94.7984V88.3725C94.7984 92.7908 91.2167 96.3725 86.7985 96.3725L45.9612 96.3726H25.124V78.9222H29.6822V20.7544Z",
  fill: "#F4F4F4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.6821 54.3623H17.9612V90.5556C17.9612 93.7681 20.585 96.3724 23.8216 96.3724C27.0583 96.3724 29.6821 93.7681 29.6821 90.5556V54.3623Z",
  fill: "#EDEDED"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.67 32.3882C42.7776 32.3882 42.0542 33.1116 42.0542 34.004C42.0542 34.8963 42.7776 35.6197 43.67 35.6197H63.8803C64.7727 35.6197 65.4961 34.8963 65.4961 34.004C65.4961 33.1116 64.7727 32.3882 63.8803 32.3882H43.67ZM43.67 53.7164C42.7776 53.7164 42.0542 54.4398 42.0542 55.3321C42.0542 56.2245 42.7776 56.9479 43.67 56.9479H65.1826C66.075 56.9479 66.7984 56.2245 66.7984 55.3321C66.7984 54.4398 66.075 53.7164 65.1826 53.7164H43.67ZM42.0542 77.3066C42.0542 76.4143 42.7776 75.6909 43.67 75.6909H65.1826C66.075 75.6909 66.7984 76.4143 66.7984 77.3066C66.7984 78.199 66.075 78.9224 65.1826 78.9224H43.67C42.7776 78.9224 42.0542 78.199 42.0542 77.3066ZM42.0542 85.7086C42.0542 84.8163 42.7776 84.0929 43.67 84.0929H54.764C55.6564 84.0929 56.3798 84.8163 56.3798 85.7086C56.3798 86.601 55.6564 87.3244 54.764 87.3244H43.67C42.7776 87.3244 42.0542 86.601 42.0542 85.7086ZM73.9612 77.3066C73.9612 76.4143 74.6846 75.6909 75.577 75.6909H82.1128C83.0052 75.6909 83.7286 76.4143 83.7286 77.3066C83.7286 78.199 83.0052 78.9224 82.1128 78.9224H75.577C74.6846 78.9224 73.9612 78.199 73.9612 77.3066ZM75.577 53.7164C74.6846 53.7164 73.9612 54.4398 73.9612 55.3321C73.9612 56.2245 74.6846 56.9479 75.577 56.9479H82.1128C83.0052 56.9479 83.7286 56.2245 83.7286 55.3321C83.7286 54.4398 83.0052 53.7164 82.1128 53.7164H75.577ZM42.0542 63.7342C42.0542 62.8418 42.7776 62.1184 43.67 62.1184H57.3687C58.261 62.1184 58.9844 62.8418 58.9844 63.7342C58.9844 64.6265 58.261 65.3499 57.3687 65.3499H43.67C42.7776 65.3499 42.0542 64.6265 42.0542 63.7342ZM73.9612 34.004C73.9612 33.1116 74.6846 32.3882 75.577 32.3882H82.1128C83.0052 32.3882 83.7286 33.1116 83.7286 34.004C83.7286 34.8963 83.0052 35.6197 82.1128 35.6197H75.577C74.6846 35.6197 73.9612 34.8963 73.9612 34.004ZM43.67 40.7902C42.7776 40.7902 42.0542 41.5136 42.0542 42.406C42.0542 43.2983 42.7776 44.0217 43.67 44.0217H52.8105C53.7029 44.0217 54.4263 43.2983 54.4263 42.406C54.4263 41.5136 53.7029 40.7902 52.8105 40.7902H43.67Z",
  fill: "#DEDEDE"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 82.4262,
  cy: 82.0461,
  rx: 19.5349,
  ry: 19.5349,
  fill: "#FFD500"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 72.0076,
  y: 92.4648,
  width: 2.60465,
  height: 20.8372,
  rx: 1.30233,
  transform: "rotate(-90 72.0076 92.4648)",
  fill: "#FBFBFB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 72.0076,
  y: 87.2554,
  width: 2.60465,
  height: 5.2093,
  rx: 1.30233,
  fill: "#FBFBFB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 90.2402,
  y: 87.2554,
  width: 2.60466,
  height: 5.2093,
  rx: 1.30233,
  fill: "#FBFBFB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.979 73.5517C80.979 72.8487 81.5749 72.2788 82.3099 72.2788C83.0449 72.2788 83.6407 72.8487 83.6407 73.5517L83.6407 81.7208L85.2519 80.1798C85.7717 79.6827 86.6143 79.6827 87.134 80.1798C87.6538 80.6769 87.6538 81.4829 87.134 81.98L83.3698 85.5803C83.081 85.8565 82.6926 85.9792 82.3152 85.9485C81.9374 85.9796 81.5484 85.8569 81.2593 85.5804L77.495 81.9801C76.9753 81.483 76.9753 80.677 77.495 80.18C78.0148 79.6829 78.8574 79.6829 79.3771 80.18L80.979 81.7121L80.979 73.5517Z",
  fill: "#FBFBFB"
}));

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20.8372,
  height: 20.8372,
  fill: "white",
  transform: "translate(72.0076 71.6274)"
})));

var SvgEdi = function SvgEdi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edi.768f6d71.svg";
export { ForwardRef as ReactComponent };